<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
// import './assets/style/js/jquery.fullPage'
export default {
  name: 'App'
}
</script>

<style>
::-webkit-scrollbar
{
    width: 10px;
    height: 16px;
    background-color: #Fff;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
    -webkit-box-shadow: inset 0 0 6px #fff;
    border-radius: 10px;
    background-color: #Fff;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(207, 198, 198, 0.3);
    background-color: rgba(144, 147, 153, 0.3);
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}

*{
  border: 0;
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue